import { gettext } from '@eventbrite/i18n';
import { getAttendees } from '../../selectors/order/typedOrderSelectors';
import { CheckoutState } from '../../state';
import { getAttendeeFirstName } from '../forms';
import { isMyOrderFormPage, isOrganizerQuestionsPage } from '../routing';

export const getAttendeesSelectorOptions = (state: CheckoutState) => {
    const attendees = getAttendees(state);
    const isOrgQuestionsPage = isOrganizerQuestionsPage(state);
    const isPreTicketsOrgPage = isMyOrderFormPage(state);

    return attendees.map(({ id, ticketClassName }, ticketIndex) => {
        const ticketSectionName = gettext(
            'Ticket %(ticketNumber)s · %(ticketClassName)s',
            {
                ticketNumber: ticketIndex + 1,
                ticketClassName,
            },
        );

        const attendeeFirstName =
            isOrgQuestionsPage || isPreTicketsOrgPage
                ? getAttendeeFirstName(state, id)
                : null;

        return {
            value: id,
            display: attendeeFirstName || ticketSectionName,
        };
    });
};
